import i18n from 'l10n';
const {Backbone, _} = require('backboneAdapter');
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import FileRowView from 'js/views/file.row.view';
import ContentFileUploadTemplate from 'js/templates/contentfileupload.hbs';
import md5 from 'md5';
require('js/models/content.model');
require('l10n');
require('jqueryUI');
require('jsFileUpload');
require('iFrameTransport');

export default Backbone.View.extend({
    el: $("#file-upload-container"),
    dropZonePartial: Handlebars.compile('{{>dropzone}}'),
    startHidden: false,
    render: function () {
        var uploadTemplate = Handlebars.compile(ContentFileUploadTemplate);
        var self = this;
        var $zone = $(this.dropZone);
        if (this.myDomId) {
            var id = this.myDomId();
            this.$el.attr("id", id);
        }
        var $uploadEl = $(uploadTemplate({"inVoucherConfiguration": this.inVoucherConfiguration}));
        this.$el.append($uploadEl);

        var fileInput = self.$('.fileinput-button input');
        $zone.append(this.dropZonePartial());
        $zone.on("drag dragstart dragover dragenter dragleave drop", function (e) {
            e.preventDefault();
//				e.stopPropagation();
        });
        $zone.bind('dragover dragenter', {el: self}, self.dragOver);
        $zone.find('.dropcontent').bind('dragleave dragend', {el: self}, self.dragLeave);

        this.$zone = $zone;

        fileInput.click(function () {
            self.$('.delete').click();
        }).fileupload({
            dataType: 'json',
            url: self.model.get("uploadUrl"),
            autoUpload: false,
            dropZone: $zone,
            pasteZone: $(".paste"),
            singleFileUploads: true,
            limitMultiFileUploads: 1,
            maxNumberOfFiles: 1,
            submit: function (e, data) {

            },
            send: function (e, data) {

            },
            add: function (e, data) {
                var file = data.files[0];
                if (!self.checkFileValidity(file, self)) {
                    return;
                }

                var maxFileSize = 5 * 1024 * 1024; //5Mb
                if(file.size > maxFileSize) {
                    $.Notify.error(`${i18n.t("content.failed")}. ${i18n.t("content.maxfilesize")}`);
                    return;
                }

                var fileReader = new window.FileReader();
                fileReader.onload = async function (e) {
                    let md5checksum = md5(e.target.result);
                    console.log(`MD5 = ${md5checksum}`);
                    try {
                        const {id: existingId} = await $.ajaxDefaultQ({
                            url: `/CampaignCloud/Content/md5exists/${md5checksum}`,
                            type: 'GET',
                            dataType: 'json'
                        });
                        console.log(`id = ${existingId}`);
                        if (!existingId) {
                            self.fileRowViewsCounter++;
                            file.innerView = new FileRowView({
                                model: new Backbone.Model({
                                    file: file,
                                    output: "Uploading started",
                                    percent: 0,
                                    myID: self.fileRowViewsCounter
                                })
                            });

                            file.innerView.updateStatus(i18n.t("content.uploading"));
                            data.submit();
                            data = null;
                        } else {
                            $.Notify.error(i18n.t("content.failedReasonItemExists"));
                        }
                    } catch (e) {
                        console.error(e);
                    }
                };
                fileReader.readAsBinaryString(file);

            },
            //ToDo: check drop area
            drop: function (e, data) {
                $(self.dropZone).find(".dropcontent").removeClass('in');
                data.eventOccurred = "drop";
                var originalTarget = e.delegatedEvent.target;

                $.each(data.files, function () {
                    if ($('.content-gallery-container').find(originalTarget).length !== 0) {
                        data.dropArea = "Content";
                    }
                    else {
                        data.dropArea = undefined;
                    }
                });
            },
            change: function (e, data) {
                data.eventOccurred = "change";
            },
            done: function (e, data) {
                $.each(data.files, function (index, file) {
                    if (data.result.status === "fail") {
                        if (data.result.msg === "alreadyexists") {
                            file.innerView.abort(i18n.t("content.failed") + i18n.t("content.failedReasonItemExists"));
                            $.Notify.error(i18n.t("content.failedReasonItemExists"));
                        } else if (data.result.msg === "filenamesanitazation") {
                            file.innerView.abort(i18n.t("content.failed") + i18n.t("content.failedReasonFilename"));
                            $.Notify.error(i18n.t("content.failedReasonFilename"));
                        } else {
                            file.innerView.abort(i18n.t("content.failed") + data.result.msg);
                            $.Notify.error(i18n.t("content.failed"));
                        }
                    } else {
                        file.innerView.updateStatus(`${i18n.t("content.fileuploaded") + data.result.msg}`);
                        $.Notify.show(`${i18n.t("content.fileuploaded")} ${data.result.msg}`);
                        self.trigger("uploaded:content");
                    }
                });
            },
            fail: function (e, data) {
                $.each(data.files, function (index, file) {
                    if (e.type === "fileuploadfail") {
                        file.innerView.abort();
                        if (data.jqXHR.status === 413) {
                            $.Notify.error(`${i18n.t("content.failed")}. ${i18n.t("content.maxfilesize")}`);
                        }

                    }
                    file.innerView.updateStatus(`${i18n.t("content.failed")}. ${i18n.t("content.maxfilesize")}`);
                });
            },
            progress: function (e, data) {
                $.each(data.files, function (index, file) {
                    var progress = parseInt(data.loaded / data.total * 100, 10);
                    file.innerView.updateProgress(progress);
                    file.innerView.updateStatus(`${i18n.t("content.upload") + progress}%`);
                });
            }
        });
        this.$('[data-i18n]').i18n();
        self.$('.progress-bar').css({"visibility": "hidden"});
        if (this.startHidden) $uploadEl.hide();
    },
    initialize: function (options) {
        this.fileAPISupport = this.checkForFileAPISupport();
        this.inServiceConfiguration = options.inServiceConfiguration || false;
        this.inVoucherConfiguration = options.inVoucherConfiguration || false;
        this.startHidden = options.startHidden;
        var self = this;
        self.fileRowViewsCounter = 0;
        this.dropZone = options.dropZone || document;
        // Click event causes uploading of only one file each time!!! (removes old after changing input)
        this.render();

    },
    checkForFileAPISupport: function () {
        // Check for the various File API support:
        // True: Great success! All the File APIs are supported.
        // False: The File APIs are not fully supported in this browser.
        return window.File && window.FileReader && window.FileList && window.Blob;
    },
    readBlob: function (opt_startByte, opt_stopByte) {
        var files = document.getElementById('files').files;
        if (!files.length) {
            dhtmlx.alert(i18n.t("content.selectfile"));
            return;
        }

        var file = files[0];
        var start = parseInt(opt_startByte) || 0;
        var stop = parseInt(opt_stopByte) || file.size - 1;

        var reader = new FileReader();

        // If we use onloadend, we need to check the readyState.
        reader.onloadend = function (evt) {
            if (evt.target.readyState === FileReader.DONE) { // DONE == 2
                document.getElementById('byte_content').textContent = evt.target.result;
                document.getElementById('byte_range').textContent =
                    ['Read bytes: ', start + 1, ' - ', stop + 1,
                        ' of ', file.size, ' byte file'].join('');
            }
        };

        var blob = file.slice(start, stop + 1);
        reader.readAsBinaryString(blob);
    },

    checkFileValidity: function (file) {
        var mimeType = file.type;
        var mimeTypeArray = mimeType.split("/");
        var fileType = mimeTypeArray[0];

        if (this.inServiceConfiguration) {
            //todo add check for supported file types
            if (fileType !== "image") {
                $.Notify.show(i18n.t("fileup.notsupportedfileForVoucher"));
                return false;
            }
        }
        return true;
    },

    superUpdateCallback: GenericView.prototype.updateCallback,
    updateCallback: function (attributeName, value, outcome, e, settings) {
        if ("OK" === outcome) {
            var newHtml = "true" === value.toString() ? "true" : "";
            $(e).find('.hidden').html(newHtml);
            if (value) {
                $(e).removeClass('busy');
                $(e).addClass('available');
            } else {
                $(e).addClass('busy');
                $(e).removeClass('available');
            }
        }
        return this.superUpdateCallback(attributeName, value, outcome, e, settings);
    },
    events: {},

    hide: function () {
        this.$el.hide();
    },
    show: function () {
        this.$el.show();
    },
    dragLeave: function (e) {
        var self = e.data.el;
        var myDropZone = ".dropcontent";
        self.$zone.find(myDropZone).removeClass('in');
    },
    dragOver: function (e) {
        if (_.filter(e.originalEvent.dataTransfer.items, i => i.kind === "file").length === 0) return;
        var self = e.data.el;
        var myDropZone = ".dropcontent";
        self.$zone.find(myDropZone).addClass('in');
    }
});
